<template>
  <header class="dashboard-header bg-white dark:bg-slate-900">
    <notification-bell @open-notification-panel="openNotificationPanel" />
    <div class="relative">
      <agent-details @toggle-menu="toggleOptions" />
      <options-menu
        :show="showOptionsMenu"
        @toggle-accounts="$emit('toggle-accounts')"
        @show-support-chat-window="toggleSupportChatWindow"
        @key-shortcut-modal="$emit('key-shortcut-modal')"
        @close="toggleOptions"
      />
    </div>
  </header>
</template>

<script>
import NotificationBell from './sidebarComponents/NotificationBell.vue';
import AgentDetails from './sidebarComponents/AgentDetails.vue';
import OptionsMenu from './sidebarComponents/OptionsMenu.vue';
import { ACCOUNT_EVENTS } from '../../helper/AnalyticsHelper/events';

export default {
  components: {
    NotificationBell,
    AgentDetails,
    OptionsMenu,
  },
  data() {
    return {
      showOptionsMenu: false,
    };
  },
  methods: {
    toggleOptions() {
      this.showOptionsMenu = !this.showOptionsMenu;
    },
    toggleSupportChatWindow() {
      if (window.$chatwoot) {
        window.$chatwoot.toggle();
      }
    },
    openNotificationPanel() {
      this.$track(ACCOUNT_EVENTS.OPENED_NOTIFICATIONS);
      this.$emit('open-notification-panel');
    },
  },
};
</script>

<style scoped lang="scss">
.dashboard-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-shrink: 0;
  height: 80px;
  padding: 0 20px;
  border-bottom: 1px solid #e5e5e5;
}

.dark .dashboard-header {
  border-color: #1e293b;
}
</style>
